export default __webpack_public_path__ + "static/media/2.5ba78f8c.png";